import React from "react";
import { Route, Switch } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { isDesktop } from "shared/util/EnvironmentHelpers";
import { RECAPTCHA_SITE_KEY_V3 } from "shared/util/constants";
import { ROUTES } from "routers/shared/util/consts";

import Login from "apps/login";

const App = process.env.PLATFORM === "desktop"
	? require("apps/splash_desktop/App").default
	: require("apps/splash_mobile/App").default;

const Splash = () => (
	<GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY_V3}>
		{isDesktop ? (
			<>
				<Route component={App} />
				<Route exact path={ROUTES.SplashLogin} component={Login} />
			</>
		) : (
			<Switch>
				<Route exact path={ROUTES.SplashLogin} component={Login} />
				<Route component={App} />
			</Switch>
		)}
	</GoogleReCaptchaProvider>
);

export default Splash;



// WEBPACK FOOTER //
// ./src/apps/splash/index.js